import { service } from "../utils/request";
//添加运费模板
export function addFreight(data) {
  return service({
    url: "shop/agent.express/add",
    method: "post",
    data: data
  });
}
//获取运费模板列表
export function getFreights(data) {
  return service({
    url: "shop/agent.express/index",
    method: "post",
    data: data
  });
}
// 获取编辑模板信息
export function editFreights(data) {
  return service({
    url: "shop/agent.express/detail",
    method: "post",
    data: data
  });
}
// 编辑修改
export function uploadFreights(data) {
  return service({
    url: "shop/agent.express/edit",
    method: "post",
    data: data
  });
}
// 删除模板
export function delFreights(data) {
  return service({
    url: "shop/agent.express/del",
    method: "post",
    data: data
  });
}
// 模板设置默认
export function setFreights(data) {
  return service({
    url: "shop/agent.express/is_default",
    method: "post",
    data: data
  });
}
// 邮费设置
export function postageSet(data) {
  return service({
    url: "shop/agent.setting/freight",
    method: "post",
    data: data
  });
}
// 邮费设置显示
export function showPostageSet(data) {
  return service({
    url: "shop/agent.setting/freightConfig",
    method: "post",
    data: data
  });
}
